import { gql, useLazyQuery, useMutation } from '@apollo/client';

export const TALENT_PROFESSION_PAYLOAD = gql`
    fragment TalentProfessionPayload on TalentProfession {
        _id
        name
        professionName
        groupName
        essaiRequired
    }
`;

export const GET_TALENT_PROFESSIONS_QUERY = gql`
    query getProfiession {
        professions: getTalentProfessions {
            ...TalentProfessionPayload
            specialties {
                specialtyName
                name
                _id
            }
        }
    }
    ${TALENT_PROFESSION_PAYLOAD}
`;

export const useGetTalentProfessions = (options?: any) => {
    return useLazyQuery(GET_TALENT_PROFESSIONS_QUERY, options);
};

export const updateTalentProfessionsProQuery = gql`
    mutation updateTalentProfessionsFreelance($professions: [ID!]!) {
        updateTalentProfessionsPro(professions: $professions) {
            _id
            professions {
                ...TalentProfessionPayload
            }
        }
    }
    ${TALENT_PROFESSION_PAYLOAD}
`;

export const useUpdateTalentProfessions = profileType => {
    return useMutation(updateTalentProfessionsProQuery);
};

export const ADD_TALENT_PROFESSION_PRO = gql`
    mutation addTalentProfessionPro($name: String!, $order: Int) {
        data: addTalentProfessionPro(name: $name, order: $order) {
            _id
            name
            groupName
            category
            status
            order
        }
    }
`;
